import styles from './Header.module.scss';
import Button from '../../common/Button/Button';
import ButtonNeutral from '../../common/ButtonNeutral/ButtonNeutral';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  return (
    <>
      {/* <NavBar /> */}
      <div className={styles.header}>
        <div className={styles.container}>
          <div>
            <div>
              <h1 className={styles.title}>
                Wspieramy zdrowie psychiczne i rozwój
              </h1>
              <p className={styles.text}>
                Psychoterapia dla dorosłych, dzieci i młodzieży. Nowoczesne
                podejście, empatia i profesjonalizm.
              </p>
            </div>
            <div className={styles.button}>
              <Button onClick={() => navigate('/contact')}>Umów wizytę</Button>
              <ButtonNeutral href='#offers'>Zobacz ofertę</ButtonNeutral>
            </div>
          </div>
          <div className={`${styles.box} ${styles.rightBox}`}>
            <h3>
              „Nie jestem tym, co mi się przydarzyło, jestem tym, kim wybrałem
              być.”
            </h3>
            <p className={styles.text}> Carl Gustav Jung</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
